// Lecture vidéo fiable partout : iPhone enregistre en .mov/HEVC que la plupart
// des navigateurs ne savent pas lire — Cloudinary transcode en MP4 H.264 à la volée.
export function toPlayableVideoUrl(url = "") {
  if (!/res\.cloudinary\.com\/[^/]+\/video\/upload\//.test(url)) return url;
  if (/\/video\/upload\/[^/]*(f_mp4|vc_h264)/.test(url)) return url;
  return url
    .replace("/video/upload/", "/video/upload/f_mp4,vc_h264,q_auto/")
    .replace(/\.[a-z0-9]{2,4}(\?[^#]*)?$/i, ".mp4$1");
}

// Miniature auto : première image de la vidéo (Cloudinary), sinon "" (le poster reste vide)
export function videoPosterUrl(url = "") {
  if (!/res\.cloudinary\.com\/[^/]+\/video\/upload\//.test(url)) return "";
  return url
    .replace(/\/video\/upload\/(?:[^/]*[a-z]_[^/]*\/)?/, "/video/upload/so_0,f_jpg,q_auto/")
    .replace(/\.[a-z0-9]{2,4}(\?[^#]*)?$/i, ".jpg$1");
}

export function isVideoFileUrl(url = "", type = "") {
  if (/youtube\.com|youtu\.be|vimeo\.com/.test(url)) return false;
  return (
    /\.(mp4|webm|ogg|mov|m4v)(\?|$)/i.test(url) ||
    /res\.cloudinary\.com\/[^/]+\/video\/upload\//.test(url) ||
    /\/api\/uploads\//.test(url) ||
    type === "url"
  );
}
